import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { OfferDetail, OfferWrite } from 'types/api'
import { BaseParams } from 'types/utils'

export function useUpdateOffer() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError

  const { t } = useTranslation('offers') // Added translation hook

  async function createOffer({ id, body }: BaseParams<OfferWrite, 'PATCH'>) {
    const res = await apiClient.patch<OfferDetail>(
      SNA_PREFIX + `offers/${id}/`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: createOffer,
    onSuccess: () => {
      toast.success({ message: t('toast.offerUpdated') })
      // Refresh both the detail (hero + cards) and the offers list.
      queryClient.invalidateQueries({ queryKey: ['offers-detail'] })
      queryClient.invalidateQueries({ queryKey: ['offers'] })
    },
    onError // Updated to use useOnError
  })
}
